import { ComputedRef, ref, Ref } from 'vue'
import { StateField, StateFieldConfig } from '../StateField'
import { option } from '@base/@motiv/fe-patterns'
import { LocationQueryValue } from 'vue-router'

export type SelectStateFieldConfig = StateFieldConfig<SelectStateField> & {
  type: 'select'
  default?: string[]
  overrideValue?: Ref<string[]>

  inputType?: 'select' | 'multiselect' | 'sort'
  inputPlaceholder?: string
  inputOptions: option[] | Ref<option[]>
}

export class SelectStateField extends StateField {
  readonly type = 'select'
  default: string[]
  value: Ref<string[]>

  inputType: 'select' | 'multiselect' | 'sort'
  inputPlaceholder?: string
  inputOptions: Ref<option[]>

  constructor(config: SelectStateFieldConfig) {
    super(config)

    this.value = config.overrideValue || ref(config.default || [])
    this.inputType = config.inputType || 'select'
    this.default = config.default || []
    this.inputPlaceholder = config.inputPlaceholder
    if (Array.isArray(config.inputOptions)) {
      this.inputOptions = ref(config.inputOptions)
    } else {
      this.inputOptions = config.inputOptions
    }
  }

  toRouteValue(): string | undefined {
    if (this.toRouteValueOverride) return this.toRouteValueOverride(this)

    if (this.value.value.toString() === this.default.toString()) {
      return undefined
    } else {
      return this.value.value.sort().join(',')
    }
  }
  pullRouteQueryValue(value: LocationQueryValue | LocationQueryValue[]): void {
    if (this.pullRouteQueryValueOverride)
      return this.pullRouteQueryValueOverride(this, value)

    if (Array.isArray(value)) {
      this.value.value = value.toString().split(',')
    } else if (value) {
      this.value.value = [value.toString()]
    } else {
      this.resetValue()
    }
  }
  pullRouteParamValue(value: string | string[]): void {
    if (this.pullRouteParamValueOverride)
      return this.pullRouteParamValueOverride(this, value)

    if (Array.isArray(value)) {
      this.value.value = value
    } else {
      this.value.value = [value]
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async toRequestVariable(variation: number): Promise<any> {
    if (this.toRequestVariableOverride)
      return await this.toRequestVariableOverride(this, variation)

    if (variation === 1) {
      return this.value.value[0]
    }
    return this.value.value
  }

  resetValue(): void {
    if (this.resetValueOverride) return this.resetValueOverride(this)

    this.value.value = this.default
  }
}
